<template>
    <section class="cabinet__search-and-basket">
        <form class="cabinet__search--public" @submit.prevent="sendSearch">
            <input
                v-model="search"
                type="text"
                placeholder="Поиск в каталоге"
                @keyup.enter="sendSearch"
            />

            <button type="submit"></button>
        </form>

        <router-link :to="`${isRetailerPatch}/cart`" class="cabinet__basket">
            <i class="cabinet__basket-icon">
                <span
                    v-if="amountCart > 0"
                    :class="{ 'over-99': amountCart > 99 }"
                    class="cabinet__quantity-in-the-basket"
                    >{{ amountCart > 99 ? '99+' : amountCart }}</span
                >
            </i>
            Корзина
        </router-link>
        <div
            class="cabinet__hamburger js-catalog-button-mobile"
            @click="showHamburgerMenuStore"
        ></div>
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'SearchAndBasket',

    data() {
        return {
            search: ''
        }
    },

    computed: {
        ...mapGetters('user', ['isRetailer']),
        ...mapGetters(['publicSearchGlobal', 'totalAmountCartPublic']),
        ...mapGetters('cart', {
            totalAmountCartRetailer: 'cartCount'
        }),
        isRetailerPatch() {
            return this.isRetailer ? '/account' : ''
        },
        amountCart() {
            return this.isRetailer
                ? this.totalAmountCartRetailer
                : this.totalAmountCartPublic
        }
    },

    created() {
        if (this.$route.params.id === 'all') {
            if (this.publicSearchGlobal) {
                this.search = this.publicSearchGlobal
            }

            if (this.$route.query.search) {
                this.search = this.$route.query.search

                this.setPublicSearchGlobal(this.search)
            }
        }
    },

    methods: {
        ...mapActions(['setPublicSearchGlobal', 'showHamburgerMenuStore']),
        sendSearch() {
            this.setPublicSearchGlobal(this.search)

            this.$router.push({
                name: 'CategoryID',
                params: { id: 'all' },
                query: { search: this.search }
            })
        }
    }
}
</script>
